import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import toastr from 'toastr';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as loginActions from '../../actions/login/index';

/*Components*/
import LoginForm from '../../components/login/loginForm';
import RequestResetPasswordPopup from '../../components/login/requestResetPasswordPopup';

/*Styles*/
import '../../../../public/style/main.scss';

const popupIds = {
  resetPasswordPopup: "resetPasswordPopup"
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        email: '',
        password: '',
        rememberMe: false
      },
      resetPasswordFormData: {
        recover_email: ''
      }
    };
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.login.status===200 && prevProps.login.status !==200) {
      this.props.history.push(Constants.app.routes.home);
    }
    
    //manage toastr errors
    if (prevProps.requestResetPassword.status !== 200 && this.props.requestResetPassword.status === 200) {
      if(this.state.showResetPasswordPopup==true) { 
        this.handleShowResetPasswordPopup();
      }
      toastr.options = Constants.interface.tostrOptions;
      toastr.success(
        intl.formatMessage({ id: "login.requestResetPassword.feedbackMessages.emailSent.info" }), 
        intl.formatMessage({ id: "login.requestResetPassword.feedbackMessages.emailSent.title" })
      );
      this.handleShowResetPasswordPopup();
    }
  }

  async componentDidMount() {
    const currentPath = window.location.pathname;
    if (currentPath === '/sso_error') {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(
        intl.formatMessage({ id: "login.singleSignOnError" }), 
        intl.formatMessage({ id: "login.singleSignOnErrorTitle" })
      );
      this.props.history.push(Constants.app.routes.login);
    }
  }

  handleLogin = async event => {
    event.preventDefault();
    await this.props.actions.login({
      user: this.state.formData
    });
  };

  handleRequestResetPassword = async event => {
    event.preventDefault();
    await this.props.actions.requestResetPassword({
      user: { email: this.state.resetPasswordFormData.recover_email }
    });
  };

  handleOnChange = event => {
    let formData = { ...this.state.formData };
    
    if(event.target.type=="checkbox") {
      formData[event.target.id] = event.target.checked;
    }
    else {
      formData[event.target.id] = event.target.value;
    }
    
    this.setState({
      formData
    });
  };

  handleOnChangeResetPasswordForm = event => {
    let resetPasswordFormData = { ...this.state.resetPasswordFormData };
    resetPasswordFormData[event.target.id] = event.target.value;
    
    this.setState({
      resetPasswordFormData
    });
  };

  handleShowResetPasswordPopup = event => {
    if(event) {
      event.preventDefault()
    };    
    if(this.props.requestResetPassword.loading) {
      return;
    }    
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.resetPasswordPopup])) {
      this.state.resetPasswordFormData.recover_email = '';
      this.props.actions.resetRequestResetPassword();
      InterfaceTooling.popupShow(popupIds.resetPasswordPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.resetPasswordPopup, this.setState.bind(this));
    }
  };

  render() {
    return (
      <div className="login_view">
        <LoginForm
          errors={this.props.login.errors}
          handleLogin={this.handleLogin}
          handleOnChange={this.handleOnChange}
          handleShowResetPasswordPopup={this.handleShowResetPasswordPopup}
          status={this.props.login.status}
          loading={this.props.login.loading}
          formData={this.state.formData}
        />
        <RequestResetPasswordPopup
          handleShowPopup={this.handleShowResetPasswordPopup}
          handleButton={this.handleRequestResetPassword}
          loadingButton={this.props.requestResetPassword.loading}
          statusButton={this.props.requestResetPassword.status}
          handleOnChangeResetPasswordForm={this.handleOnChangeResetPasswordForm}
          resetPasswordFormData={this.state.resetPasswordFormData}
          popupState={this.state[popupIds.resetPasswordPopup]}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  login: state.reducer.login.login,
  requestResetPassword: state.reducer.login.requestResetPassword
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(loginActions, dispatch)
});

Login.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./source/client/containers/login/index.jsx